import React from 'react';
import Select, { MultiValue } from 'react-select';
import { DropdownStyles } from 'app/components/common/common-styles';
import { AppCategory } from 'app/console-api/apps/categories';

type Option = { label: string; value: number };

export interface AppCategoriesSelectProps {
  categories: AppCategory[];
  selectedIds: number[];
  handleChange: (ids: number[]) => void;
}

export const AppCategoriesSelect = ({
  categories,
  selectedIds,
  handleChange
}: AppCategoriesSelectProps) => {
  // Build stable options from categories
  const options = React.useMemo<Option[]>(
    () => categories.map((cat) => ({ label: cat.name, value: Number(cat.id) })),
    [categories]
  );

  // Derive value directly from options + selectedIds
  const value = React.useMemo<Option[]>(
    () => options.filter((opt) => selectedIds.includes(opt.value)),
    [options, selectedIds]
  );

  // (Optional) memoize styles object if it's heavy
  const styles = React.useMemo(() => DropdownStyles(), []);

  return (
    <Select<Option, true>
      aria-label="Tasks Categories Select"
      options={options}
      value={value}
      isMulti
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
      onChange={(next: MultiValue<Option>) => {
        handleChange(next.map((opt) => opt.value));
      }}
      // Helps react-select consistently identify options
      getOptionValue={(o) => String(o.value)}
      getOptionLabel={(o) => o.label}
      styles={styles}
    />
  );
};
